import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import Swal from 'sweetalert2';
import IRMDEdit from './ManufacturingDomestic/Edit';
// import MRNMDEdit from './ManufacturingDomestic/Edit';

function InspectionEdit() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [inspectionreporttype, setinspectionreporttype] = useState('');
  const [inspectionreportcategory, setinspectionreportcategory] = useState('');
  const [data, setData] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}inspectionReport/findById/${id}`, {
          headers: authHeader(),
        });
        setData(response.data)
        setinspectionreporttype(response.data.inspectionreporttype);
        setinspectionreportcategory(response.data.inspectionreportcategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (inspectionreporttype === 'Tubing') {
      if (inspectionreportcategory === 'Domestic') {
        // return <TDView />;
      } else if (inspectionreportcategory === 'International') {
        // return <TIView />;
      }
    } else if (inspectionreporttype === 'Pump Spare') {
      if (inspectionreportcategory === 'International') {
        // return <PIView />;
      }
    } else if (inspectionreporttype === 'Manufacturing') {
      return <IRMDEdit />;
    }
    return null; // Default case
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}inspectionReport/delete/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          navigate(`/irindex/${pointindex}`);
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>UPDATE INSPECTION REPORT</h6>
          <div className="view-buttons">
            {/* {(inspectionreportcategory === "Domestic" || inspectionreportcategory === "International") && data?.status === "Open" && (
              <Link to={`/itopconvert/${id}`}>
                <button className="button-70">Convert To purchase</button>
              </Link>
            )} */}
            {/* <button className="button-70" onClick={() => handleDelete(id)}>DELETE</button> */}
            {/* <Link to={`/MRNEdit/${id}/${pointindex}`}>
              <button className="button-70">EDIT</button>
            </Link> */}
            <Link to={`/irindex/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select disabled value={inspectionreporttype} onChange={(e) => setinspectionreporttype(e.target.value)}>
                  <option value="">--Please choose an option--</option>
                  <option value="Tubing">Tubing</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a PO Category:</Form.Label>
                <Form.Select disabled value={inspectionreportcategory} onChange={(e) => setinspectionreportcategory(e.target.value)}>
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default InspectionEdit;
